module.exports = __webpack_public_path__ + "static/tovifun_qrcode-9b72df0f05fee6589d65193f8fd2457b.png";